import ListItem from '../ListItem/ListItem';
import { IContactList } from '../../interfaces';
import type { TemplateStatEvent } from '../../template/contract';

const titles =
{
    email: 'Email',
    facebook: 'Facebook Messenger',
    whatsapp: 'WhatsApp',
    phone: 'Work telephone number',
    mobile: 'Cell telephone number',
    linkedin: 'LinkedIn',
    website: 'Website'
}

// phone/mobile tragen zusätzlich einen national formatierten Anzeigewert
// (phoneDisplay/mobileDisplay, Kontrakt v2) — eigene Felder auf `contacts`,
// keine eigenständige Zeile. Über die Marken-Allowlist ist `phone`/`mobile`
// unabhängig von `phoneDisplay`/`mobileDisplay` ab-/anwählbar (Block-B-Review
// Punkt B) — deshalb entscheidet über Anzeige/Verschwinden der Zeile, ob
// IRGENDEINER der beiden Werte vorhanden ist, nicht nur `value`.
const DISPLAY_ONLY_KEYS = new Set<string>(['phoneDisplay', 'mobileDisplay']);
const DISPLAY_KEY_FOR: Partial<Record<keyof IContactList, keyof IContactList>> = {
    phone: 'phoneDisplay',
    mobile: 'mobileDisplay',
};

const hasText = (value?: string): value is string => !!value && value.trim() !== '';

interface ContactsListProps {
    contacts: IContactList;
    /** Kontrakt v3, additiv (T-31): wird an jede ListItem-Zeile durchgereicht. */
    onEvent?: (event: TemplateStatEvent) => void;
}

function ContactsList({ contacts, onEvent } : ContactsListProps)
{
    return (
        <div style = {{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style = {{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {
                Object.entries(contacts)
                    .filter(([key]) => !DISPLAY_ONLY_KEYS.has(key))
                    .map(([key, value]) => {
                        const displayKey = DISPLAY_KEY_FOR[key as keyof IContactList];
                        const displayValue = displayKey ? contacts[displayKey] : undefined;
                        if (!hasText(value) && !hasText(displayValue)) return null;
                        return (
                            <ListItem
                                key = {key}
                                title = {Object(titles)[key]}
                                // Link-/Rohwert: bevorzugt der E.164-Wert; fehlt er (phone
                                // von der Allowlist abgewählt, nur phoneDisplay übrig),
                                // ist ein funktionierender Link wichtiger als exakte
                                // Formatierung — dann verlinkt der Anzeigewert selbst.
                                value = {hasText(value) ? value : (displayValue as string)}
                                displayValue = {displayValue}
                                onEvent = {onEvent}
                            />
                        );
                    })
            }
            </div>
        </div>
    )
}

export default ContactsList;